<template>
  <div class="preview-product" ref="container">
    <div class="preview-product-main">
      <div class="header-center">此页面为商品预览页</div>
      <div class="bread"></div>
      <div class="body-center">
        <div class="product-img-message">
          <div class="product-img">
            <div class="bigImg-container">
              <el-image
                style="width: 420px; height: 420px"
                v-if="bigimg"
                class="big-img"
                :src="bigimg"
                :fit="'contain'"
              ></el-image>
              <img v-else class="no-img" src="../../../assets/product/bigImg.png" alt />
            </div>
            <div class="img-banner">
              <el-button
                :class="ltdDisabled?'lt disabled':'lt'"
                :disabled="ltdDisabled"
                @click="moveToRight"
              >
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2018"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20"
                  height="20"
                >
                  <path
                    d="M622.927311 789.137615c-6.503881 0-13.007763-2.16796-18.066337-7.226535l-231.249118-231.249118c-10.117149-10.117149-15.898377-23.847565-15.898377-39.023289 0-14.45307 5.781228-28.183486 15.898377-39.023288l231.971771-231.971772c10.117149-10.117149 26.015526-10.117149 35.410022 0 10.117149 10.117149 10.117149 26.015526 0 35.410021l-231.249118 231.971772c-0.722653 0.722653-1.445307 2.16796-1.445307 2.890614 0 0.722653 0 2.16796 1.445307 2.890614l231.249118 231.249118c10.117149 10.117149 10.117149 26.015526 0 35.410021-5.058574 5.781228-11.562456 8.671842-18.066338 8.671842z"
                    p-id="2019"
                    fill="#fff"
                  />
                </svg>
              </el-button>
              <div class="list-container" ref="list-container">
                <ul class="list" ref="list">
                  <li
                    class="smallImg-container"
                    @mouseover="over(value)"
                    v-for="(value,index) in imgs"
                    :key="index"
                  >
                    <el-image class="small-img" :src="value" fit="contain"></el-image>
                  </li>
                </ul>
              </div>
              <el-button
                :class="gtdDisabled?'gt disabled':'gt'"
                :disabled="gtdDisabled"
                @click="moveToLeft"
              >
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2507"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20"
                  height="20"
                >
                  <path
                    d="M385.174312 788.414961c-6.503881 0-13.007763-2.16796-18.066337-7.226535-10.117149-10.117149-10.117149-26.015526 0-35.410021l231.249117-231.249118c1.445307-1.445307 1.445307-4.335921 0-5.781228l-231.249117-232.694425c-10.117149-10.117149-10.117149-26.015526 0-36.132674s26.015526-10.117149 36.132674 0l231.971772 231.971771c21.679605 21.679605 21.679605 56.366972 0 77.323924l-231.249118 231.249118c-5.781228 5.781228-12.285109 7.949188-18.788991 7.949188z"
                    p-id="2508"
                    fill="#fff"
                  />
                </svg>
              </el-button>
            </div>
          </div>
          <div class="product-message">
            <div class="trade-name">{{goodsName}}</div>
            <div class="promotion">{{ goodsInfo }}</div>
            <div>
              <!-- 普通商品 -->
              <div class="price">
                <span class="space4">价格</span>
                <span class="DF3445">￥{{ price }}</span>
              </div>
              <div class="specification">
                <sku-select @has-select-sku="onSelectedSku" :skuOriginData="skuOriginData"></sku-select>
              </div>
              <div class="number">
                <span class="number-tit">数量</span>
                <el-input-number v-model="num" controls-position="right" :min="1" :max="1"></el-input-number>
                <p class="stock">库存999件</p>
              </div>
              <div class="button">
                <el-button class="add-to-cart" disabled>加入购物车</el-button>
                <el-button class="collection" disabled>收藏</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="recommend-detail">
          <!-- 推荐商品 -->
          <div class="recommend">
            <p class="title">推荐商品</p>
            <div class="no-preview">无法预览</div>
          </div>
          <!-- 商品详情页 -->
          <div class="detail">
            <p class="title">商品详情</p>
            <div v-if="content" v-html="content"></div>
            <div v-else class="noContent">
              <img src="../../../assets/product/detail.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkuSelect from "base/xb-base/SkuSelect";
import DBCommodity from "models/db/commodity.js";
const dbCommodity = new DBCommodity();
export default {
  components: {
    SkuSelect
  },
  data() {
    return {
      id: null, // 当前详情页id
      imgs: [], // 所有图片数据
      bigimg: "", // 大容器图片
      number: 1, // 记录滑动数
      ltdDisabled: true, // 左滑按钮
      gtdDisabled: false, // 右滑按钮
      goodsName: "", // 商品标题
      goodsInfo: "", // 商品副标题
      price: null, // 当前选中sku对应的价格
      skuOriginData: [], // sku数据
      sku: [], // 选中的sku
      stock: 0, // 当前sku库存
      num: 1, // 商品的数量
      content: "" // 详情页内容
    };
  },
  watch: {},
  created() {
    this.id = Number(this.$route.query.id);
    this.getProductDetail();
  },
  mounted() {},
  methods: {
    // 获取商品详情数据
    getProductDetail() {
      let id = this.id;
      dbCommodity.getDBDetailGoods(id).then(res => {
        console.log(res);
        if (res.success) {
          this.status = res.result.status;
          this.imgs = res.result.itemImages;
          this.bigimg = res.result.itemImages[0];
          this.gtdDisabled = !(res.result.itemImages.length > 5);
          this.goodsName = res.result.goodsName;
          this.goodsInfo = res.result.goodsInfo;
          this.stock = res.result.totalSaleNum;
          this.price = res.result.defaultPrice;
          if (res.result.introduction) {
            this.getJsonp(res.result.introduction);
          }
          let arr = [];
          res.result.items.map((value, index, array) => {
            let obj = value.specInfo;
            obj.skuId = {};
            obj.skuId.id = value.id;
            obj.skuId.price = value.marketPrice;
            obj.skuId.num = value.saleNum;
            arr.push(obj);
          });
          this.skuOriginData = arr;
          console.log(this.skuOriginData);
        }
      });
    },
    // jsonp
    getJsonp(url) {
      var hash = new Date().getTime();
      let script = document.createElement("script");
      window.jsonpCallBack = response => {
        let str = response.content;
        this.content = str;
      };
      script.src = url + `?hash=${hash}`;
      document.body.appendChild(script);
      script.onload = function(e) {
        e.currentTarget.remove();
        delete window.jsonpCallBack;
      };
      script.onerror = function(e) {
        // alert("数据请求失败");
        e.currentTarget.remove();
        delete window.jsonpCallBack;
      };
      window.jsonpCallback = response => {
        let str = response.content;
        this.content = str;
      };
      script.onload = function(e) {
        e.currentTarget.remove();
        delete window.jsonpCallback;
      };
      script.onerror = function(e) {
        // alert("数据请求失败");
        e.currentTarget.remove();
        delete window.jsonpCallback;
      };
    },
    // 左滑
    moveToLeft() {
      let containerWidth = this.$refs["list-container"].clientWidth + 20;
      let width = this.$refs["list"].clientWidth;
      if (width > containerWidth) {
        let sum = (width - containerWidth) / 80;
        console.log(sum);
        if (this.number < sum) {
          this.$refs["list"].style.left = -this.number * 80 + "px";
          this.number = this.number + 1;
          this.ltdDisabled = false;
        } else if (this.number === sum) {
          this.$refs["list"].style.left = -this.number * 80 + "px";
          this.number = this.number + 1;
          this.ltdDisabled = false;
          this.gtdDisabled = true;
        } else {
          this.ltdDisabled = false;
          this.gtdDisabled = true;
        }
      }
    },
    // 右滑
    moveToRight() {
      if (this.number > 1) {
        this.number = this.number - 1;
        this.$refs["list"].style.left = -(this.number - 1) * 80 + "px";
        if (this.number === 1) {
          this.ltdDisabled = true;
          this.gtdDisabled = false;
        }
      }
    },
    // hover small-img
    over(value) {
      this.bigimg = value;
    },
    // 返回的sku数据
    onSelectedSku(item) {
      console.log(item);
      this.sku = item;
      this.price = item[item.length - 1].price;
      this.stock = item[item.length - 1].num;
    }
  }
};
</script>
<style lang='scss' scoped>
.preview-product {
  min-height: 100%;
  background: #fff;
  .preview-product-main {
    .header-center {
      height: 100px;
      line-height: 100px;
      font-size: 48px;
      text-align: center;
      color: #cfcfcf;
      margin: 0 auto;
      width: 1200px;
    }
    .body-center {
      margin: 0 auto;
      width: 1200px;
    }
    .bread {
      height: 2px;
      background: #df3445;
      margin-bottom: 8px;
    }
    .product-img-message {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .product-img {
        width: 420px;
        height: 490px;
        .bigImg-container {
          width: 420px;
          height: 420px;
          box-sizing: border-box;
          border: 1px solid #e4e4e4;
          border-radius: 8px;
          margin-bottom: 10px;
          font-size: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          .big-img {
            max-width: 100%;
            max-height: 99%;
          }
          .no-img {
            opacity: 0.5;
          }
        }
        .img-banner {
          width: 420px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .lt {
            margin: 0 2px;
            width: 16px;
            height: 40px;
            background: rgba(31, 45, 61, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            border-radius: 0;
            border: 0px;
          }
          .lt:hover {
            background: rgba(31, 45, 61, 0.3);
          }
          .gt {
            margin: 0 2px;
            width: 16px;
            height: 40px;
            display: flex;
            padding: 0;
            background: rgba(31, 45, 61, 0.1);
            align-items: center;
            justify-content: center;
            border-radius: 0;
            border: 0px;
          }
          .gt:hover {
            background: rgba(31, 45, 61, 0.3);
          }
          .disabled:hover {
            background: rgba(31, 45, 61, 0.1);
          }
          .list-container {
            height: 60px;
            flex: 1;
            overflow: hidden;
            position: relative;
            .list {
              display: flex;
              height: 60px;
              position: absolute;
              left: 0;
              transition: all 0.5s;
              /* transform: translate(100px, 0); */
              .smallImg-container {
                box-sizing: border-box;
                min-width: 60px;
                height: 60px;
                margin-right: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                .small-img {
                  width: 56px;
                  height: 56px;
                }
              }
            }
          }
        }
      }
      .product-message {
        width: 740px;
        min-height: 420px;
        .trade-name {
          white-space: pre-wrap;
          width: 580px;
          padding: 8px 0;
          font-size: 16px;
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          line-height: 28px;
          min-height: 28px;
        }
        .promotion {
          font-size: 12px;
          color: rgba(223, 52, 69, 1);
          line-height: 20px;
          min-height: 20px;
          padding: 6px 0 20px 0px;
        }
        .price {
          height: 80px;
          background: rgba(247, 247, 247, 1);
          border-radius: 2px;
          box-sizing: border-box;
          padding-left: 10px;
          color: #606266;
          display: flex;
          align-items: center;
          .space4 {
            width: 60px;
            padding-right: 10px;
            font-size: 12px;
            letter-spacing: 2px;
          }
          .DF3445 {
            font-size: 24px;
            color: #df3445;
          }
          .no-price {
            font-size: 16px;
            color: #df3445;
          }
        }
        .specification {
          margin-bottom: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #e4e4e4;
          padding-left: 10px;
          padding-top: 12px;
        }
        .number {
          height: 40px;
          padding-left: 10px;
          margin-bottom: 10px;
          display: flex;
          align-items: flex-start;
          .number-tit {
            width: 60px;
            padding-right: 10px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(96, 98, 102, 1);
            line-height: 20px;
            letter-spacing: 2px;
          }
          .stock {
            line-height: 40px;
            height: 18px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
            letter-spacing: 1px;
            padding-left: 10px;
          }
        }
        .button {
          height: 40px;
          display: flex;
          .add-to-cart {
            width: 128px;
            height: 40px;
            background: rgba(223, 52, 69, 0.75);
            border-radius: 2px;
            border: 0;
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            padding: 0;
          }
          .add-to-cart:hover {
            background: rgba(223, 52, 69, 1);
          }
          .nothing {
            width: 128px;
            height: 40px;
            background: rgba(145, 147, 152, 1);
            border-radius: 2px;
            border: 2px solid rgba(145, 147, 152, 1);
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            padding: 0;
          }
          .collection {
            margin-left: 20px;
            width: 72px;
            height: 40px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 2px solid rgba(223, 52, 69, 1);
            font-size: 16px;
            font-weight: 500;
            color: rgba(223, 52, 69, 1);
            padding: 0;
          }
        }
      }
    }
    .recommend-detail {
      display: flex;
      min-height: 100px;
      justify-content: space-between;
      margin-bottom: 30px;
      .title {
        height: 40px;
        background: #f7f7f7;
        font-size: 16px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        line-height: 40px;
        letter-spacing: 2px;
        padding-left: 10px;
        border: 1px solid #e4e4e4;
        border-bottom: 0;
        margin: 0;
      }
      .recommend {
        width: 200px;
        /* visibility: hidden; */
        .no-preview {
          padding-top: 60px;
          color: #cfcfcf;
          text-align: center;
          font-size: 25px;
        }
      }
      .detail {
        width: 980px;
        min-height: 800px;
        .noContent {
          width: 100%;
          height: 500px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            opacity: 0.5;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.preview-product {
  .preview-product-main {
    .el-radio-group {
      height: 24px;
      .el-radio-button {
        height: 24px;
        margin-right: 8px;
        .el-radio-button__inner {
          height: 24px;
          line-height: 24px;
          padding: 0;
          min-width: 60px;
          padding: 0 8px;
          border-radius: 2px;
          border: 1px solid rgba(151, 151, 151, 1);
          box-shadow: 0 0 0 0;
          color: #606266;
          background: #fff;
        }
      }
      .el-radio-button.is-active {
        .el-radio-button__inner {
          border: 1px solid #df3445;
        }
      }
      .el-radio-button:hover {
        .el-radio-button__inner {
          color: #df3445;
        }
      }
    }
    .number {
      .el-input-number {
        width: 80px;
        line-height: 31px;
        .el-icon-arrow-up {
          color: #979797;
        }
        .el-icon-arrow-down {
          color: #979797;
        }
        .el-input-number__decrease {
          box-sizing: border-box;
          width: 18px;
          height: 14px;
          border-radius: 2px;
          border: 1px solid rgba(151, 151, 151, 1);
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .el-input-number__increase {
          box-sizing: border-box;
          width: 18px;
          height: 14px;
          border-radius: 2px;
          border: 1px solid rgba(151, 151, 151, 1);
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .el-input {
          width: 56px;
          .el-input__inner {
            padding: 0 8px;
            height: 32px;
            border-radius: 2px;
            border: 1px solid rgba(151, 151, 151, 1);
            font-size: 16px;
            color: rgba(96, 98, 102, 1);
            line-height: 28px;
          }
        }
      }
    }
    .detail {
      width: 980px;
      min-height: 800px;
      font-size: 14px;
      img {
        max-width: 100%;
      }
      table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        width: 100% !important;
      }
      table td,
      table th {
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        padding: 3px 5px;
      }
      table th {
        border-bottom: 2px solid #ccc;
        text-align: center;
      }

      /* blockquote 样式 */
      blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
      }

      /* code 样式 */
      code {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        background-color: #f1f1f1;
        border-radius: 3px;
        padding: 3px 5px;
        margin: 0 3px;
      }
      pre code {
        display: block;
      }

      /* ul ol 样式 */
      ul,
      ol {
        margin: 10px 0 10px 20px;
        li {
          line-height: 32px;
        }
      }
      ol {
        li {
          list-style: decimal;
        }
      }
      ul {
        li {
          list-style: disc;
        }
      }
      p {
        line-height: 1.5;
        margin: 10px 0;
      }
    }
  }
}
</style>
